import { useState } from 'react';
import { Box, Skeleton, Typography, pn } from '@compass/core';
import { Column } from 'devextreme-react/data-grid';
import { EnrollmentByAdvisorDistributionDto, EnrollmentByAdvisorMonthlyDistributionDto } from 'generated/openApi';
import { DevExpressReport } from 'components';
import { DashboardCard } from '../components/DashboardCard';
import { useEnrollmentByAdvisorData } from '../contexts';
import { EnrollmentByAdvisorControls, EnrollmentPeriod } from './EnrollmentByAdvisorControls';

export const EnrollmentByAdvisorTableCard = () => {
    const { data, monthlyData: monthlyDistributionData, loading, error } = useEnrollmentByAdvisorData();
    const monthlyData = monthlyDistributionData as EnrollmentByAdvisorMonthlyDistributionDto[];
    const [period, setPeriod] = useState<EnrollmentPeriod>('year');
    const [month, setMonth] = useState<number | null>(null);
    const filteredMonthlyData = monthlyData.filter(item => month === null || item.month === month);

    return <DashboardCard title="Enrollment by Advisor">
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <EnrollmentByAdvisorControls
                period={period}
                onPeriodChange={setPeriod}
                month={month}
                onMonthChange={setMonth}
            />
            {loading ? <Skeleton variant="rounded" height={400} /> : error ?
                <Typography color="error" align="center">{error}</Typography> :
                <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                    <DevExpressReport dataSource={period === 'month' ? filteredMonthlyData : data} fullPageSize showColumnChooser={false}>
                        <Column dataField={pn<EnrollmentByAdvisorDistributionDto>('year')} caption="School Year"
                            cellRender={({ value }) => `${value}-${value + 1}`} />
                        {period === 'month' && <Column
                            dataField={pn<EnrollmentByAdvisorMonthlyDistributionDto>('month')}
                            caption="Start Month"
                            cellRender={({ data: row }) => new Date(row.startYear, row.month - 1).toLocaleString(undefined, {
                                month: 'long',
                                year: 'numeric',
                            })}
                        />}
                        <Column dataField={pn<EnrollmentByAdvisorDistributionDto>('enrollmentByAdvisorName')} caption="Advisor" />
                        <Column dataField={pn<EnrollmentByAdvisorDistributionDto>('studentCount')} caption="Students" />
                        <Column dataField={pn<EnrollmentByAdvisorDistributionDto>('percentage')} caption="Percentage"
                            cellRender={({ value }) => `${value}%`} />
                    </DevExpressReport>
                </Box>}
        </Box>
    </DashboardCard>;
};
